"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Home_1 = __importDefault(require("../../networking/apis/Home"));
const IconReset_1 = __importDefault(require("../../assets/icons/IconReset"));
const scale_1 = require("../../utils/scale");
const ModalSharePost_1 = __importDefault(require("../modal/ModalSharePost"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const helpler_1 = require("../../utils/helpler");
const IconRetweet = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { idPost, height, data, dataTweet, displayTweet, disabled = false } = props || 0;
    const [dataIdRetweet, setDataIdtweet] = (0, react_1.useState)();
    const buttonShareRef = (0, react_1.useRef)(null);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0, left: 0 });
    const [visibleModalShare, setVisibleModalShare] = (0, react_1.useState)(false);
    //   const dispatch = useDispatch();
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const [value, setValue] = (0, react_1.useState)(data?.userId == dataUser?.user_id && data?.type == 2);
    const isAnonymous = dataUser?.registration_status == 0;
    const firestorePath = () => {
        if (data?.type == 2) {
            const path = data?.repostTweetPath;
            let containsRelai = path?.indexOf('replies') != -1;
            let parts = '';
            let textAfterSlash = null;
            let textpath = null;
            if (containsRelai) {
                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
            }
            else {
                parts = path.split('/');
                textAfterSlash = parts[1];
            }
            return textpath ? textpath : 'tweets';
        }
        else {
            const path = data?.path;
            let containsRelai = path?.indexOf('replies') != -1;
            let parts = '';
            let textAfterSlash = null;
            let textpath = null;
            if (containsRelai) {
                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
            }
            else {
                parts = path.split('/');
                textAfterSlash = parts[1];
            }
            return textpath ? textpath : 'tweets';
        }
    };
    (0, react_1.useEffect)(() => {
        if (react_native_1.Platform.OS === 'web' && !value) {
            const { firebase } = require('../../../web/firebase/config');
            try {
                firebase
                    .firestore()
                    .collection('users')
                    .doc(dataUser?.user_id.toString())
                    .collection('retweetTweets')
                    .doc(idPost)
                    .onSnapshot((snapshot) => {
                    if (snapshot.data()) {
                        setDataIdtweet(snapshot.data()?.retweetId);
                        setValue(true);
                    }
                    else {
                        setValue(false);
                    }
                });
            }
            catch {
                (err) => { console.log('sadas', err); };
            }
        }
    }, [idPost]);
    const handlePressShare = (event) => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        const position = buttonShareRef.current?.getBoundingClientRect();
        const { pageX, pageY } = event.nativeEvent;
        setModalPosition({ x: position.right, y: position.bottom, left: position.left });
        setVisibleModalShare(true);
    };
    const callApiPostTweet = async () => {
        const dataRePost = new FormData();
        dataRePost.append('type', 2);
        dataRePost.append('retweet_id', idPost);
        dataRePost.append('is_reply', 0);
        dataRePost.append('publication_range', 0);
        dataRePost.append('content', '');
        await Home_1.default.tweetPostApi(dataRePost)
            .then((_res) => {
            setVisibleModalShare(false);
            dispatch(slice_1.default.actions.showToast('引用しました'));
        })
            .catch((_err) => { });
    };
    const callApiDeleteTweet = async () => {
        let id = idPost;
        if (data?.type == 2) {
            if (data.userId != dataUser?.user_id) {
                id = dataIdRetweet;
            }
            else {
                id = data?.tweetId || data?._id;
            }
        }
        else if (data?.type == 1) {
            id = dataIdRetweet;
        }
        await Home_1.default.deletePostApi(id)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast('引用を取り消しました'));
            setVisibleModalShare(false);
            displayTweet(id);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { ref: buttonShareRef, style: {
                flexDirection: 'row',
                alignItems: 'center',
            }, onPress: handlePressShare, disabled: disabled },
            react_1.default.createElement(IconReset_1.default, { color: value ? '#44A06B' : '#545454', height: height || (0, scale_1.scale)(18) })),
        react_1.default.createElement(ModalSharePost_1.default, { visible: visibleModalShare, onClose: () => setVisibleModalShare(false), modalPosition: modalPosition, typeshared: value, retweet: () => {
                !value ? callApiPostTweet() : callApiDeleteTweet();
            }, shareComent: () => (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_POST, {
                data: `${(0, helpler_1.urlPost)(`${firestorePath()}/${idPost}`)}`,
                type: 'POST',
            }) })));
};
exports.default = IconRetweet;
